import React, { useState } from 'react'
import { IconButton, Icon } from 'rsuite'
import { useHistory } from 'react-router-dom'
import { isSomeBoxEdit } from '../../../utils/widget'
import PopupModal from '../../modal/PopupModal'

export default function BtnEditAll(props) {
  const history = useHistory()
  const {
    routing,
    hiddenBtnEdit,
    onClickEditAll,
    disabled,
    setOnClickEditAll,
    editWidget,
    forms,
    // isShowForce,
    // onClickForwardBackward = () => {},
  } = props

  const [isShowForce, setIsShowForce] = useState(false)
  const [forceType, setForceType] = useState(false)

  const onForward = () => {
    // handleForwardBackward('forward')
    handleForwardBackwardConfirm('forward')
  }

  const onBackward = () => {
    // handleForwardBackward('backward')
    handleForwardBackwardConfirm('backward')
  }

  const handleForwardBackward = (type) => {
    // console.log('handleForwardBackwardConfirm forms=', forms)
    if (editWidget && isSomeBoxEdit(editWidget, forms)) {
      setIsShowForce(true)
      setForceType(type)
    } else {
      setIsShowForce(false)
      handleForwardBackwardConfirm(type)
    }
  }

  const handleForwardBackwardConfirm = (forceType) => {
    // console.log('handleForwardBackwardConfirm forceType=', forceType)
    if (forceType == 'forward') {
      history.push({
        pathname: `${routing.pathNameForward}`,
      })
    } else {
      history.push({
        pathname: `${routing.pathNameBackward}`,
      })
    }
  }

  return (
    <>
      <div style={{ textAlign: 'right', marginBottom: '10px' }}>
        {routing && (
          <>
            {routing?.pathNameForward && (
              <IconButton
                appearance="ghost"
                className="rs-btn-ghost-info"
                style={{ marginRight: '3px' }}
                icon={<Icon className="bt-gost-icon-radius-info" icon="backward" />}
                // disabled={disabled}
                onClick={onForward}
              >
                ขั้นตอนก่อนหน้า
              </IconButton>
            )}
            {routing?.pathNameBackward && (
              <IconButton
                appearance="ghost"
                className="rs-btn-ghost-info"
                style={{ marginRight: '8px' }}
                icon={<Icon className="bt-gost-icon-radius-info" icon="forward" />}
                // disabled={disabled}
                onClick={onBackward}
              >
                ขั้นตอนถัดไป
              </IconButton>
            )}
          </>
        )}

        {!hiddenBtnEdit && (
          <IconButton
            appearance="ghost"
            className={onClickEditAll ? 'rs-btn-ghost-cancel' : 'rs-btn-ghost-edit'}
            style={{
              marginRight: '3px',
            }}
            icon={
              <Icon
                icon={onClickEditAll ? 'close' : 'edit'}
                className={
                  onClickEditAll ? 'bt-gost-icon-radius-cancel' : 'bt-gost-icon-radius-edit'
                }
              />
            }
            onClick={() => {
              setOnClickEditAll(!onClickEditAll)
            }}
            disabled={disabled}
          >
            {onClickEditAll ? 'ยกเลิกการแก้ไขทั้งหมด' : 'แก้ไขทั้งหมด'}
          </IconButton>
        )}

        <PopupModal
          body={
            <p>
              มีส่วนที่แก้ไขไว้แล้วยังไม่ได้บันทึก กดปุ่ม <b>"ดำเนินการต่อ"</b>
              เพื่อไปยังขั้นตอนถัดไป/ก่อนหน้า หรือ กดกดปุ่ม <b>"ปิดหน้าต่าง"</b>
              เพื่อตรวจสอบการแก้ไขและทำการบันทึกก่อน
            </p>
          }
          isShow={isShowForce}
          onClickSubmit={() => {
            setIsShowForce(false)
            handleForwardBackwardConfirm(forceType)
          }}
          onClickCancel={() => {
            setIsShowForce(false)
          }}
          submitText="ดำเนินการต่อ"
          cancelText="ปิดหน้าต่าง"
        />
      </div>
    </>
  )
}
